import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Link20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M11.7019 3.70189C12.9711 2.43268 15.0289 2.43268 16.2981 3.70189C17.5636 4.96733 17.5673 7.01669 16.3094 8.28678L14.494 9.94645L15.5061 11.0535L17.3469 9.37062L17.3588 9.35874C19.2138 7.50375 19.2138 4.49622 17.3588 2.64123C15.5038 0.786237 12.4962 0.786237 10.6413 2.64123L8.14124 5.14124C6.28625 6.99623 6.28625 10.0038 8.14124 11.8588L9.2019 10.7981C7.9327 9.52889 7.9327 7.47111 9.2019 6.2019L11.7019 3.70189Z'
      fill='currentColor'
    />
    <path
      d='M3.7019 16.2981C2.4327 15.0289 2.4327 12.9711 3.7019 11.7019L5.53034 9.87347L4.46968 8.81281L2.64124 10.6412C0.786252 12.4962 0.786252 15.5038 2.64124 17.3588C4.49623 19.2137 7.50377 19.2137 9.35876 17.3588L11.8587 14.8588C13.7137 13.0038 13.7137 9.99623 11.8587 8.14124L10.7981 9.2019C12.0673 10.4711 12.0673 12.5289 10.7981 13.7981L8.2981 16.2981C7.02889 17.5673 4.97111 17.5673 3.7019 16.2981Z'
      fill='currentColor'
    />
  </Svg>
);

Link20.displayName = 'Link20';
export default Link20;
